export default __webpack_public_path__ + "static/media/information--camera--g2.d5adb6c7.png";